import { render, staticRenderFns } from "./PhoneWebrtcVideo.vue?vue&type=template&id=28c1af5a&scoped=true&lang=pug&"
import script from "./PhoneWebrtcVideo.vue?vue&type=script&lang=js&"
export * from "./PhoneWebrtcVideo.vue?vue&type=script&lang=js&"
import style0 from "./PhoneWebrtcVideo.vue?vue&type=style&index=0&id=28c1af5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1af5a",
  null
  
)

export default component.exports